import(/* webpackMode: "eager" */ "/vercel/path0/next/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-noto-sans\",\"display\":\"swap\"}],\"variableName\":\"notoSans\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Lora\",\"arguments\":[{\"subsets\":[\"latin-ext\"],\"variable\":\"--font-lora-serif\",\"display\":\"swap\",\"weight\":[\"400\",\"600\",\"700\"]}],\"variableName\":\"LoraSerif\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/next/node_modules/react-wrap-balancer/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/next/src/app/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeForm"] */ "/vercel/path0/next/src/app/components/subscribe-form.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/app/globals.css");
